import { ZOOM_NODE, FILTER_GRAPH, RESET, TOGGLE_FDWS_ONLY} from './actionTypes';

export function zoomOnNode(_id) {
  return {type: ZOOM_NODE, _id}
}

export function filterGraph(filter) {
  return {type: FILTER_GRAPH, filter}
}

export function resetGraph() {
  return {type: RESET}
}

export function toggleFDWsOnly() {
  return { type: TOGGLE_FDWS_ONLY };
}